export default __webpack_public_path__ + "static/media/AdobeStock_167781326_x3.18012df2.jpg";